import i18next from 'i18next'
import { HttpResult } from 'widgets-for-react'
import { canSafelyCast, TypeCastingValidator } from '../../../../utils/safe-type-casting'
import { FiltersData } from './filtersLoaderState'

export const filtersApi = async (): Promise<HttpResult<FiltersData>> => {
  const res = await fetch(`/api/v1/filters?language=${i18next.language}`)
  if (!res.ok)
    return {
      kind: 'failed',
      status: res.status,
    }
  else {
    const json = await res.json()

    const filtersDataValidator: TypeCastingValidator<FiltersData> = {
      kind: 'object',
      fieldsValidator: {
        MainCategories: {
          kind: 'array',
          elementValidator: {
            kind: 'object',
            fieldsValidator: {
              Translation: { kind: 'string' },
              Title: { kind: 'string' },
              Subcategories: {
                kind: 'array',
                elementValidator: {
                  kind: 'object',
                  fieldsValidator: {
                    Translation: { kind: 'string' },
                    Title: { kind: 'string' },
                    Ingredients: {
                      kind: 'array',
                      elementValidator: {
                        kind: 'object',
                        fieldsValidator: {
                          Translation: { kind: 'string' },
                          Title: { kind: 'string' },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
        Techniques: {
          kind: 'array',
          elementValidator: {
            kind: 'object',
            fieldsValidator: {
              Translation: { kind: 'string' },
              Title: { kind: 'string' },
            },
          },
        },
        Appearances: {
          kind: 'array',
          elementValidator: {
            kind: 'object',
            fieldsValidator: {
              Translation: { kind: 'string' },
              Title: { kind: 'string' },
            },
          },
        },  
        Textures: {
          kind: 'array',
          elementValidator: {
            kind: 'object',
            fieldsValidator: {
              Translation: { kind: 'string' },
              Title: { kind: 'string' },
            },
          },
        },              
        Allergens: {
          kind: 'array',
          elementValidator: {
            kind: 'object',
            fieldsValidator: {
              Translation: { kind: 'string' },
              Title: { kind: 'string' },
            },
          },
        },
      },
    }
    const maybeFiltersData = canSafelyCast<FiltersData>(
      filtersDataValidator,
      json
    )

    return maybeFiltersData.kind == 'r'
      ? {
          kind: 'result',
          value: maybeFiltersData.v,
          status: res.status,
        }
      : {
          kind: 'failed',
          status: res.status,
        }
  }
}
